<template>
  <div class="creditCycle">
    <Row class="content">
      <Col span="12" class="ad">
        <h3>{{$t('other.w86')}}</h3>
        <p>{{$t('other.w87')}}</p>
        <div class="tip">
          <i></i>
          <span>{{$t('label.w135')}}</span>
        </div>
        <ul class="desc">
          <li>{{$t('other.w88')}}</li>
          <li>{{$t('other.w89')}}</li>
          <li>{{$t('other.w90')}}</li>
          <li>{{$t('other.w91')}}</li>
        </ul>
      </Col>
      <Col span="12" class="bg">
        <div class="img-bg"></div>
      </Col>
    </Row>
    <div :style="{position: 'relative',minHeight:'240px'}">
      <Spin size="large" fix v-if="infoloading"></Spin>
      <div v-if="info.CanRevolveApply&&(info.Statu==-2||info.Statu==-1||info.Statu==4||info.Statu==5)" class="swInput">
        <Row class="apply">
          <Col span="12" class="lines">
            <p>{{$t('label.w190')}}</p>
            <Input :placeholder="$t('pl.p17')" v-model="amount">
              <span slot="suffix">{{$t('label.w5')}}</span>
            </Input>
            <span class="canuse">{{$t('label.w184')}}：{{info.CreditAvailableAmount | money}}{{$t('label.w5')}}</span>
          </Col>
          <Col span="12" class="lines pdl">
            <p>{{$t('label.w191')}}</p>
            <Input :value="amountUpper" :readonly="true"/>
          </Col>
        </Row>
        <div class="credit">
          <Button type="primary" :loading="btnLoading" @click="submit">{{$t('btn.b20')}}</Button>
        </div>
      </div>
      <div v-else class="creditState">
        <div class="state">
          <div class="text">
            <div v-if="info.CanRevolveApply===false">{{$t('option.w18')}}</div>
            <div v-if="info.Statu==0">{{$t('option.w19')}}</div>
            <div v-if="info.Statu==1">
              <p>{{$t('option.w20')}}</p>
              <router-link :to="{name:'revolvingLoan'}">{{$t('nav.w57')}}</router-link>
            </div>
            <div v-if="info.Statu==2||info.Statu==3">{{$t('option.w21')}}<small>[{{info.LoanNumber}}]</small></div>
          </div>
        </div>
      </div>
    </div>
    <div class="creditList">
      <h3 class="t3">{{$t('title.w50')}}</h3>
      <Datatable
        url="/Member/RZJLoan/RevolvingHistory"
        :th="[$t('label.w192'),$t('label.w193'),$t('label.w131'),$t('label.w194'),$t('label.w53')]"
        field="RevolvingHistory"
        v-slot="{item}"
        ref="datatable"
        :tip="$t('msg.m104')"
      >
        <tr>
          <td>{{item.CreatedAt}}</td>
          <td><span class="amount">¥ {{item.Amount | money}}</span></td>
          <td>{{item.AcceptedAt}}</td>
          <td>{{item.Number}}</td>
          <td>{{item.StatusName}}</td>
        </tr>
      </Datatable>
    </div>
  </div>
</template>

<script>
import { digitUppercase } from "@/libs/static";
import Datatable from "@/components/datatable";
export default {
  components: { Datatable },
  data() {
    return {
      state: 4,
      amount: "",
      info: {},
      infoloading: true,
      btnLoading: false,
    };
  },
  computed: {
    amountUpper() {
      return digitUppercase(this.amount);
    }
  },
  methods: {
    getinfo() {
      this.$axios.get("/Member/RZJLoan/ToDayRevolveInfo").then(res => {
        this.infoloading = false;
        if (res.err) return;
        this.info = res;
      });
    },
    submit(){
      this.btnLoading = true
      if(this.amount==''||isNaN(this.amount)) return this.$Message.error(this.$t('msg.m61'));
      this.$axios.post('/Member/RZJLoan/ApplyRevolving',{
        amount:this.amount
      })
      .then(res=>{
        this.btnLoading = false
        res.throw();
        if(!res.err){
          this.getinfo();
          this.$refs.datatable.refresh();
        }
      })
    }
  },
  mounted() {
    this.getinfo();
  }
};
</script>
<style lang="less" scoped>
.creditCycle {
  .content {
    margin-top: 20px;
    .ad {
      padding-left: 110px;
      background: url("../../assets/assetcenter/public_quotes.png") no-repeat;
      background-size: 78px 74px;
      background-position: 80px 150px;
      h3 {
        font-size: 48px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
      p {
        font-size: 14px;
        color: rgba(179, 179, 182, 1);
      }
      .tip {
        font-weight: 500;
        color: rgba(94, 143, 252, 1);
        font-size: 14px;
        margin-top: 30px;
        span {
          margin-left: 5px;
        }
        i {
          display: inline-block;
          background: url("../../assets/assetcenter/public_hint.png") no-repeat;
          width: 14px;
          height: 13px;
          background-size: cover;
        }
      }
      .desc {
        margin-top: 30px;
        margin-left: 15px;
        position: relative;
        li {
          width: 439px;
          font-size: 14px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 20px;
          letter-spacing: 1;
          list-style: decimal;
        }
      }
    }
    .bg {
      padding-top: 50px;
      padding-left: 48px;
      .img-bg {
        width: 498px;
        height: 322px;
        background: url("../../assets/assetcenter/credit_bg.png") no-repeat;
        background-size: cover;
      }
    }
  }
  .swInput {
    .apply {
      margin-top: 60px;
      display: flex;
      .lines {
        position: relative;
        padding-left: 110px;
        p {
          width: 460px;
          margin-bottom: 5px;
          font-size: 12px;
          font-weight: 500;
          color: rgba(123, 123, 124, 1);
        }
        .canuse {
          position: absolute;
          right: 30px;
          top: 0;
          color: #5e8ffc;
        }
        /deep/.ivu-input-wrapper {
          .ivu-input-suffix {
            right: 40px;
            font-size: 24px;
            color: #333;
            line-height: 70px;
          }
          .ivu-input {
            width: 460px;
            height: 72px;
            font-size: 24px;
            border-radius: 8px;
          }
        }
      }
      .pdl {
        padding-left: 30px;
        position: relative;
        &::before {
          content: "";
          width: 16px;
          height: 14px;
          background: url("../../assets/assetcenter/public_create.png")
            no-repeat;
          background-size: cover;
          position: absolute;
          left: -10px;
          top: 47px;
        }
      }
      .sw-icon {
        position: absolute;
        i {
          display: inline-block;
          width: 16px;
          height: 14px;
          background: url("../../assets/assetcenter/public_create.png")
            no-repeat;
          background-size: cover;
        }
      }
    }
    .credit {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 50px;
      margin-bottom: 69px;
      .ivu-btn {
        width: 360px;
        height: 50px;
        background: linear-gradient(
          90deg,
          rgba(129, 169, 250, 1) 0%,
          rgba(74, 112, 242, 1) 100%
        );
        border-radius: 25px;
      }
    }
  }
  .creditState {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 230px;
    margin-top: 69px;
    .state {
      width: 316px;
      height: 237px;
      background: url("../../assets/assetcenter/credit_ordernone.png") no-repeat;
      background-size: cover;
      .text {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 190px;
        height: 180px;
        margin-left: 55px;
        margin-top: 5px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 30, 135, 1);
        small{
          display: block;
          font-size: 12px;
          text-align: center;
        }
      }
      a {
        margin: 15px auto 0;
        display: block;
        width: 100px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: #001e87;
        border-radius: 14px;
        border: 1px solid rgba(0, 30, 135, 1);
      }
    }
  }
  .creditList {
    .t3 {
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: 500;
      color: rgba(35, 35, 37, 1);
    }
  }
  td{
    .amount{
      font-size: 18px;
      color: #FF6106;
    }
  }
}
</style>
